"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AssetRegistry_1 = require("./core/AssetRegistry");
exports.kinoklubbBlackImage = AssetRegistry_1.default.get('kinoklubb-black');
exports.ebLogoImage = AssetRegistry_1.default.get('eblogo');
exports.appStoreImage = AssetRegistry_1.default.get('app-store');
exports.googlePlayImage = AssetRegistry_1.default.get('google-play');
exports.filmGrailImage = AssetRegistry_1.default.get('filmGrail');
exports.fredrikstadkinoImage = AssetRegistry_1.default.get('fredrikstadkino');
exports.landscapeImagePlaceholder = AssetRegistry_1.default.get('landscapeImagePlaceholder');



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-asset-provider/images.ts